import React, { Component } from "react";
import config from "lib/fr-config";
import ProfileUnitView from "presentational/portfolio/ProfileUnitView";
import IconButtonView from "presentational/common/IconButtonView";
import TXT from "presentational/common/multinational/TXT";
import { getDeviceType } from "lib/deviceInfo";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const cssXL = {
  root: {
    marginTop:
      -desktopCss.paddingBetweenHeaderbarAndFirstContent +
      desktopCss.paddingBetweenHeaderbarAndFirstContentForSplitView
  },
  buttonArea: {
    display: "flex",
    justifyContent: "flex-end"
  }
};

const cssXS = {
  root: {},
  buttonArea: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    backgroundColor: "white",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",

    height: `calc(env(safe-area-inset-bottom) + ${mobileCss.headerBarHeightPX}px)`
  },
  buttonWrapper: {
    paddingBottom: "calc(env(safe-area-inset-bottom))"
  }
};

class ProfileImgSummaryPanelView extends Component {
  static propTypes = {
    imageDataURL: PropTypes.string.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  requestMyProfile = async () => {
    const { UserProfileActions, AppErrorActions, getIdTokenWT } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await UserProfileActions.initMyProfile(idToken);
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
    }
  };

  mobileLayout() {
    const { imageDataURL, onBackClick, onSubmit, username, myProfile } =
      this.props;
    const css = cssXS;
    const { followingNum, gender, location } = myProfile;

    return (
      <div style={css.root}>
        <div>
          <ProfileUnitView
            profileType={"demo"}
            ownerName={username}
            location={location}
            followingNum={followingNum}
            gender={gender}
            image={imageDataURL}
            firstBtnText={<TXT name="btnCommonContained_demoButton" />}
            onFirstBtnClick={() => {}}
          />
        </div>
        <div style={css.buttonArea}>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"back"} onClick={onBackClick} />
          </div>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"submit"} onClick={onSubmit} />
          </div>
        </div>
      </div>
    );
  }

  desktopLayout() {
    const { imageDataURL, onBackClick, onSubmit, username, myProfile } =
      this.props;
    const css = cssXL;
    const { followingNum, gender, location } = myProfile;

    return (
      <div style={css.root}>
        <div style={css.buttonArea}>
          <IconButtonView type={"back"} onClick={onBackClick} />
          <IconButtonView
            type={"submit"}
            disableRightMargin
            onClick={onSubmit}
          />
        </div>
        <div>
          <ProfileUnitView
            profileType={"demo"}
            ownerName={username}
            location={location}
            followingNum={followingNum}
            gender={gender}
            image={imageDataURL}
            firstBtnText={<TXT name="btnCommonContained_demoButton" />}
            onFirstBtnClick={() => {}}
          />
        </div>
      </div>
    );
  }

  render() {
    return getDeviceType() === "mobile"
      ? this.mobileLayout()
      : this.desktopLayout();
  }

  componentDidMount() {
    this.requestMyProfile();
  }
}

export default withToken(
  withStore({
    stateMap: { myAccount: ["username"], userProfile: ["myProfile"] },
    dispatchMap: ["userProfile", "appError"]
  })(ProfileImgSummaryPanelView)
);
